import { useState, useEffect } from 'react';

/**
 * 检测是否为移动端视口的 Hook。
 *
 * 微信WebView兼容说明：
 * - 微信 iOS WKWebView 和 Android X5 在页面初始化时 window.innerWidth 偶尔会
 *   返回 0 或桌面尺寸，需等到 resize 事件或 DOMContentLoaded 后再判断。
 * - 使用 document.documentElement.clientWidth 作为更可靠的备选。
 */
function getViewportWidth(): number {
  // clientWidth 在微信WebView中更稳定
  const clientWidth = document.documentElement?.clientWidth;
  if (clientWidth && clientWidth > 0) return clientWidth;
  return window.innerWidth;
}

export function useIsMobile(breakpoint = 768): boolean {
  const [mobile, setMobile] = useState<boolean>(() => {
    // SSR 安全（如将来切换框架），以及微信WebView初始化兜底
    if (typeof window === 'undefined') return false;
    return getViewportWidth() < breakpoint;
  });

  useEffect(() => {
    const update = () => setMobile(getViewportWidth() < breakpoint);

    // 页面加载完成后再校正一次，兜底微信WebView初始尺寸异常
    update();

    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [breakpoint]);

  return mobile;
}
